import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void): () => void {
  document.addEventListener('visibilitychange', onStoreChange);
  return () => document.removeEventListener('visibilitychange', onStoreChange);
}

function getSnapshot(): boolean {
  return 'visible' === document.visibilityState;
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * Subscribes to the document's visibility state as reactive state.
 *
 * @returns `true` when the tab is foregrounded; `true` during SSR and hydration
 */
export function usePageVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
